import { 
    SET_VENDOR_PAYMENT, 
    SET_SPECIFIC_VENDOR_PAYMENT 
} from "../Types/VendorPaymentType";
const initialState = {
    allVendorPayment: [],
    specificVendorPayment: {},
}

const ApVendorPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_VENDOR_PAYMENT:
            return { ...state, allVendorPayment: action.payLoad };
        case SET_SPECIFIC_VENDOR_PAYMENT:
            return { ...state, specificVendorPayment: action.payLoad };
        default:
            return state;
    }
}
export default ApVendorPaymentReducer;